import React from 'react';
import Modal from 'react-responsive-modal';

interface ConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
}

const ConfirmationDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirmer',
  cancelText = 'Annuler',
  isLoading = false,
}: ConfirmationDialogProps) => {
  // react-responsive-modal typings often miss children; cast locally to avoid TS noise
  const ResponsiveModal = Modal as unknown as React.ComponentType<any>;
  const customModalStyles = {
    modal: {
      maxWidth: '500px',
      width: '90%',
      padding: '20px',
    },
  };

  return (
    <ResponsiveModal
      onClose={onClose}
      open={isOpen}
      center
      styles={customModalStyles}
    >
      <div className="p-6">
        <div className="text-xl font-bold mb-4">{title}</div>
        <div className="text-gray-700 mb-6">{message}</div>
        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="border border-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-50"
            disabled={isLoading}
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className="bg-main text-white px-4 py-2 rounded hover:bg-main-dark"
            disabled={isLoading}
          >
            {isLoading ? 'En cours...' : confirmText}
          </button>
        </div>
      </div>
    </ResponsiveModal>
  );
};

export default ConfirmationDialog;
